import { GenericReportDownload } from '@/types/downloadReports';

import { createAsyncAction } from 'typesafe-actions';

export type GetDownloadTradeTemplateRequestPayload = {
  company_entity?: string;
  is_pre_executed?: boolean;
};

export type GetDownloadTemplateSuccessPayload = {
  data: GenericReportDownload;
};

export const getDownloadTradeTemplate = createAsyncAction(
  `bulkUploader/getDownloadTradeTemplate/request`,
  `bulkUploader/getDownloadTradeTemplate/success`,
  `bulkUploader/getDownloadTradeTemplate/failure`,
)<
  GetDownloadTradeTemplateRequestPayload,
  GetDownloadTemplateSuccessPayload,
  undefined
>();

export type GetUploadTradeRequestPayload = {
  file: File;
  is_pre_executed?: boolean;
};

export const getUploadTradeTemplate = createAsyncAction(
  `bulkUploader/getUploadTradeTemplate/request`,
  `bulkUploader/getUploadTradeTemplate/success`,
  `bulkUploader/getUploadTradeTemplate/failure`,
)<GetUploadTradeRequestPayload, undefined, undefined>();
